import { Box, Typography } from "@mui/material";
import { Banner, Details } from "./components";
import { useParams } from "react-router";
import { departmentinternal } from "views/EyeCareDetails/internal-data";
import { Testimonial } from "components";
import { list as allList } from "views/EyeCareDetails/internal-data/doctors";
import { BookAppointmentStrip } from "components";
import { Helmet } from "react-helmet-async";

const EyeCareInternal = ({ doctorView }) => {
  const { id, departId } = useParams();
  const { internalData, list, listheader } = departmentinternal[departId] || {};
  const pageData = internalData?.find((item) => item.id === id) || {};
  const faqsSection = pageData?.faqsSection;

  // Split the label using "||"
  const [rawLabel1, rawLabel2] = pageData?.label?.split("||") || [];
  const label1 = rawLabel1?.trim();
  const label2 = rawLabel2?.trim();

  return (
    <Box>
      <Helmet>
        <title>{pageData?.title}</title>
        <meta name="description" content={pageData?.description || "No Description "} />
        <meta name="keywords" content={pageData?.keyword} />
        <meta name="title" content={pageData?.title} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageData?.url} />
        <meta property="og:title" content={pageData?.title} />
        <meta property="og:description" content={pageData?.description || "No Description"} />
        <meta property="og:image" content={pageData?.Imageme} />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={pageData?.url} />
        <meta property="twitter:title" content={pageData?.title} />
        <meta property="twitter:description" content={pageData?.description || "No Description"} />
        <meta property="twitter:image" content={pageData?.Imageme} />
      </Helmet>

      <Box position={"relative"}>
        <Banner text={pageData.label} bannerImg={pageData?.banner} />

        {Boolean(pageData?.label) && (
          <Box
            position="absolute"
            sx={{
              top: "50%",
              transform: "translateY(-50%)",
              left: { md: "5rem", xs: "1rem" },
            }}
          >
            {label1 && (
              <Typography
                fontSize={{ md: "2.125rem", xs: "2.25rem" }}
                fontWeight={600}
                component="h1"
              >
                {label1}
              </Typography>
            )}

            {label2 && (
              <Typography
                component="p"
                fontSize={{ md: "1.5rem", xs: "1.25rem" }}
                fontWeight={400}
              >
                {label2}
              </Typography>
            )}
          </Box>
        )}
      </Box>

      <Box mb={{ md: "10rem", xs: "2.5rem" }}>
        <BookAppointmentStrip />
      </Box>

      <Details
        data={pageData.data}
        doctorView={doctorView}
        links={departId === "general" ? allList : list}
        departId={departId}
        img={pageData.img}
        listheader={listheader}
      />

      <Testimonial />
      {faqsSection && (
        <Box py={5}>
          <Typography
            fontSize={{ md: "2.5rem", xs: "2rem" }}
            fontWeight="bold"
            textAlign="center"
            component="h2"
          >
            {faqsSection.heading}
          </Typography>
          <Box mt={3} px={{ md: 8, xs: 3 }}>
            {faqsSection.services.map((service) => (
              <Box key={service.id} mb={3}>
                <Typography fontSize={{ md: "2rem", xs: "1.5rem" }} fontWeight="bold" component="h3">
                  {service.label}
                </Typography>
                <Typography fontSize={{ md: "1.5rem", xs: "1.2rem" }}>
                  {service.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default EyeCareInternal;
